module.exports = __webpack_public_path__ + "img/selected7-min.3f04a381.png";